import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import styled from 'styled-components';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { COMMERCE } from 'self-service-api/constants/EnrolledProductLines';
import { findValidI18nKey } from 'pricing-pages-lib/utils/languageUtils';
import { hasEnrolledFeatureAtAccessLevel } from './CommerceFeatureTableConfig';
import { FeatureAvailableIcon, FeatureUnavailableIcon } from './SharedComponents';
import { OZ } from 'HubStyleTokens/colors';
const ShortLimitContent = styled.span.attrs({
  tabIndex: -1
}).withConfig({
  displayName: "CommerceFeatureTableCell__ShortLimitContent",
  componentId: "sc-1fp9h8o-0"
})(["", ""], props => props.hasTooltip && `
    cursor: help;
  `);

const FeatureAvailableIconWithOutline = () => {
  const outlineStyles = {
    outline: `2px dashed ${OZ}`,
    outlineOffset: '2px'
  };
  return /*#__PURE__*/_jsx(FeatureAvailableIcon, {
    iconProps: {
      style: outlineStyles
    }
  });
};

const IconWrapper = styled.span.attrs({
  tabIndex: -1
}).withConfig({
  displayName: "CommerceFeatureTableCell__IconWrapper",
  componentId: "sc-1fp9h8o-1"
})([""]);

const CommerceFeatureTableCell = ({
  feature,
  accessLevel,
  productLevel,
  isSuite = false,
  showTooltip = false
}) => {
  const hasFeature = isSuite && productLevel ? feature.productLevelAvailability.includes(productLevel) : hasEnrolledFeatureAtAccessLevel(feature, accessLevel);
  const shortLimitKey = findValidI18nKey([`enrolledProductLine.features.${feature.shortName}.shortLimits.${COMMERCE}.${accessLevel}`, `enrolledProductLine.features.${feature.shortName}.shortLimits.default.${accessLevel}`]);
  const longLimitKey = findValidI18nKey([`enrolledProductLine.features.${feature.shortName}.longLimits.${COMMERCE}.${accessLevel}`, `enrolledProductLine.features.${feature.shortName}.longLimits.default.${accessLevel}`]);
  const hasTooltip = isSuite || showTooltip && longLimitKey !== undefined;
  const hasFeatureCheckMark = hasFeature && !shortLimitKey && (Array.isArray(feature.hasCheckMark) ? feature.hasCheckMark.includes(accessLevel) : feature.hasCheckMark);
  const MemoShortLimitContent = useMemo(() => {
    if (!hasFeature) return /*#__PURE__*/_jsx(FeatureUnavailableIcon, {});
    if (hasFeature && !hasFeatureCheckMark && !shortLimitKey) return null;

    if (isSuite) {
      return /*#__PURE__*/_jsx(IconWrapper, {
        children: /*#__PURE__*/_jsx(FeatureAvailableIconWithOutline, {})
      });
    }

    return /*#__PURE__*/_jsx(ShortLimitContent, {
      hasTooltip: hasTooltip,
      children: hasFeatureCheckMark ? /*#__PURE__*/_jsx(FeatureAvailableIcon, {}) : /*#__PURE__*/_jsx(FormattedMessage, {
        message: shortLimitKey
      })
    });
  }, [hasFeature, hasFeatureCheckMark, shortLimitKey, isSuite, hasTooltip]);
  const tooltipContent = longLimitKey || shortLimitKey || '';
  return /*#__PURE__*/_jsx("td", {
    className: "p-x-1",
    children: hasTooltip ? /*#__PURE__*/_jsx(UITooltip, {
      use: "longform",
      placement: "left",
      disabled: !showTooltip,
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: tooltipContent
      }),
      children: MemoShortLimitContent
    }) : /*#__PURE__*/_jsx(_Fragment, {
      children: MemoShortLimitContent
    })
  });
};

export default CommerceFeatureTableCell;